export default "__VITE_ASSET__Bc5FbJv3__"